export const achievementsConfig = [
    {code: "notany", display: "Никаких из перечисленных"},
    {
        code: "olympiad",
        display: "Победа или призовое место в заключительном и промежуточных этапах олимпиады школьников"
    },
    {
        code: "olympiadMg",
        display: "Победа или призовое место в заключительном и промежуточных этапах олимпиад, конкурсов"
    },
    {code: "essays", display: "Итоговое сочинение"},
    {code: "certificatewithhonors", display: "Аттестат с отличием, золотая или серебрянная медаль"},
    {code: "sports", display: "Высокие спортивные достижения"},
    {code: "gto", display: "Золотой, серебрянный или бронзовый знак ГТО"},
    {code: "volunteering", display: "Волонтерство"},
    {code: "military", display: "Служба в армии"},
    {code: "championship", display: "Победа или призовое место в чемпионате «Абилимпикс»"},

    {code: "art_masters", display: "Победа или призовое место чемпионата по профессиональному мастерству «Профессионалы», чемпионата высоких технологий, национального открытого чемпионата творческих компетенций «АртМастерс (Мастера Искусств)»"},
    {code: "olypiad_spo", display: "Победа или призовое место в олимпиадах и иных интеллектуальных и (или) творческих конкурсах, мероприятиях, направленных на развитие интеллектуальных и творческих способностей, способностей к занятиям физической культурой и спортом, интереса к научной (научно-исследовательской), инженерно-технической, изобретательской, творческой, физкультурно-спортивной деятельности, а также на пропаганду научных знаний, творческих и спортивных достижений"},
    {code: "military_now", display: "Прохождение военной службы, пребывание в добровольческих формированиях"},
    {code: "article", display: "Наличие статей в рецензируемых научных изданиях"},
    {code: "silverMiit", display: "Серебряный знак МИИТа"},
    {code: "doc", display: "Документ установленного образца с отличием"},
]

const bakalavrAchievements = [
    "notany",
    "olympiad",
    "certificatewithhonors",
    "sports",
    "gto",
    "volunteering",
    "military",
    "championship",
]

const spoAchievements = [
    "notany",
    "olypiad_spo",
    "championship",
    "art_masters",
    "sports",
    "volunteering",
    "military_now",
]

const spo = [
    "notany",
]

const aspirant = [
    "notany",
    "article",
    "silverMiit",
    "doc",
]

const magistrant = [
    "notany",
    "olympiadMg",
    "article",
]

export const achievements = new Map<string, any[]>([
    ["БАКСПЕЦ", achievementsConfig.filter(item => bakalavrAchievements.includes(item.code))],
    ["СПО11КЛАССОВ", achievementsConfig.filter(item => spoAchievements.includes(item.code))],
    ["СПО9КЛАССОВ", achievementsConfig.filter(item => spoAchievements.includes(item.code))],
    ["000000003", achievementsConfig.filter(item => magistrant.includes(item.code))],
    ["000000008", achievementsConfig.filter(item => aspirant.includes(item.code))],
    ["0000000012", achievementsConfig.filter(item => spo.includes(item.code))]
]);